var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlusGray(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1348 18.8651C11.1351 19.492 10.6268 20.0003 10.0002 20C9.69751 20 9.41044 19.8805 9.19767 19.6678C8.98491 19.455 8.86542 19.1679 8.86542 18.8653L8.86559 11.1347L1.13491 11.1347C0.832282 11.1347 0.545209 11.0152 0.332452 10.8024C0.119822 10.5898 0.000251985 10.3028 9.51194e-08 10.0002C-0.000253859 9.37347 0.508039 8.86522 1.13462 8.86548L8.86542 8.86552L8.86538 1.13491C8.86513 0.508043 9.37337 -0.000253897 9.99999 9.51468e-08C10.627 -1.33755e-05 11.1348 0.507736 11.1348 1.1347L11.1348 8.86547L18.8653 8.86531C19.4922 8.86529 20 9.37307 20 9.99982C20.0003 10.6267 19.492 11.135 18.8654 11.1347L11.1348 11.1349L11.1348 18.8651Z",
    fill: "#00C48C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusGray);
export default __webpack_public_path__ + "static/media/plus-gray.f3a9bbc1.svg";
export { ForwardRef as ReactComponent };